import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { MenuButton } from '~/modules/Elements/Menu';
import RemoteMicClient from '~/modules/RemoteMic/Network/Client';
import { MIC_ID_KEY } from '~/modules/RemoteMic/Network/Client/NetworkClient';
import storage from '~/modules/utils/storage';
import NumericInput from '~/routes/RemoteMic/Components/NumericInput';
import { RemoteMicrophoneLagSetting, useSettingValue } from '~/routes/Settings/SettingsState';

function MicrophoneSettings() {
  const [currentValue, setCurrentValue] = useSettingValue(RemoteMicrophoneLagSetting);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    RemoteMicClient.getMicrophoneInputLag()
      .then(({ value }) => setCurrentValue(value))
      .catch((e) => console.warn(e))
      .finally(() => setIsLoading(false));
  }, []);

  const changeValue = (newValue: number) => {
    setIsLoading(true);
    RemoteMicClient.setMicrophoneInputLag(newValue)
      .then(({ value }) => setCurrentValue(value))
      .catch((e) => console.warn(e))
      .finally(() => setIsLoading(false));
  };

  const reset = () => {
    RemoteMicClient.disconnect();
    storage.local.removeItem('remote_mic_name');
    storage.local.removeItem(MIC_ID_KEY);
    global.location?.reload();
  };
  return (
    <SettingsStack>
      <ResetButton onClick={reset} size="small" data-test="reset-microphone">
        Reset microphone
      </ResetButton>
      <Note data-test={'reset-mic-info'}>
        <strong>Note:</strong> removes all persisted microphone data (your name, ID etc.)
      </Note>
      <Divider />
      <SectionTitle>Adjust microphone lag</SectionTitle>
      <NumericInput
        value={currentValue}
        onChange={changeValue}
        unit="ms"
        disabled={isLoading}
        step={25}
        data-test="microphone-delay"
      />
      <Note>Adjust the microphone input delay if the game does not detect you hitting the note on time.</Note>
    </SettingsStack>
  );
}

export default MicrophoneSettings;

const SettingsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: var(--walky-ink);
`;

const ResetButton = styled(MenuButton)`
  min-height: 48px !important;
  border-radius: 10px !important;
  font-size: 14px !important;
  font-weight: 900 !important;
`;

const SectionTitle = styled.h3`
  margin: 0;
  color: var(--walky-ink);
  font-size: 16px;
  font-weight: 900;
`;

const Note = styled.h6`
  margin: 0;
  color: var(--walky-muted);
  font-size: 12px;
  line-height: 1.35;
`;

const Divider = styled.hr`
  width: 100%;
  margin: 2px 0;
  border: 0;
  border-top: 1px solid var(--walky-border);
`;
